import React, { useEffect } from 'react'
import { TextFieldSeeker } from "@ui-seeker/core"
import useAdminNewOfficeInfo from "Pages/Admin/Users/@hooks/useNewOfficeInfo"
import { useValidatorSeeker } from "@ui-seeker/app"
import { object, string } from "yup"
import { isValidNewOffice } from "Pages/Admin/Users/@signals"


export default function OfficeNameField() {

	const { name, setNameInfo } = useAdminNewOfficeInfo("", "name")
	const { errors, isValid } = useValidatorSeeker({ name: name }, object({ name: string().required('Must provide an office name') }))

	useEffect(() => {
		isValidNewOffice.value = { ...isValidNewOffice.value, name: isValid }
	}, [isValid])

	return <TextFieldSeeker
		value={name}
		onChange={e => setNameInfo(e.target.value)}
		label="Office name"
		placeholder="Office name"
		error={errors.name}
	/>
}